import React, { Component } from "react";
import { InputGroup, Spinner } from "@blueprintjs/core";
import { BASE_API, AppToaster } from "../../utils/constants";
import "../../css/SuperAdminDashboard.scss";

class SuperAdminAdmins extends Component {
	state = {
		users: [],
		loading: true,
		editing: {}, // { userId: { name: "..." } }
	};

	componentDidMount() {
		this.getData();
	}

	async getData() {
		try {
			const res = await fetch(`${BASE_API}/api/admins`);
			const data = await res.json();
			this.setState({ users: data.users || [], loading: false });
		} catch (err) {
			AppToaster.show({ message: "Eroare la încărcarea userilor", intent: "danger" });
			this.setState({ loading: false });
		}
	}

	handleEdit = (userId, field, value) => {
		this.setState((prev) => ({
			editing: {
				...prev.editing,
				[userId]: {
					...prev.editing[userId],
					[field]: value
				}
			}
		}));
	};

	handleSave = async (userId, field) => {
		const value = this.state.editing[userId]?.[field];
		if (!value) return;

		try {
			const res = await fetch(`${BASE_API}/api/admin/users/${userId}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ [field]: value }),
			});

			if (res.ok) {
				AppToaster.show({ message: "Salvat cu succes", intent: "success" });
				this.getData();
				this.setState((prev) => {
					const newEditing = { ...prev.editing };
					delete newEditing[userId];
					return { editing: newEditing };
				});
			} else {
				throw new Error();
			}
		} catch {
			AppToaster.show({ message: "Eroare la salvare", intent: "danger" });
		}
	};

	render() {
		const { users, loading, editing } = this.state;
		console.log(users)
		if (loading) return <Spinner />;

		return (
			<div className="admin-table-container">
				{users &&
					<table className="admin-table">
						<thead>
							<tr>
								<th>Nume</th>
								<th>Organizație</th>
								<th>Email</th>
								<th>Telefon</th>
								<th>Creat la</th>
							</tr>
						</thead>
						<tbody>
							{users.map((u) => (
								<tr key={u.id}>
									<td>
										<InputGroup
											fill={true}
											style={{ minWidth: "160px" }}
											value={editing[u.id]?.name ?? u.name ?? ""}
											onChange={(e) => this.handleEdit(u.id, "name", e.target.value)}
											onBlur={() => this.handleSave(u.id, "name")}
											onKeyDown={(e) => e.key === "Enter" && this.handleSave(u.id, "name")}
										/>
									</td>
									<td>{u.organization}</td>
									<td>
										<InputGroup
											fill={true}
											style={{ minWidth: "250px" }}
											value={editing[u.id]?.email ?? u.email ?? ""}
											onChange={(e) => this.handleEdit(u.id, "email", e.target.value)}
											onBlur={() => this.handleSave(u.id, "email")}
											onKeyDown={(e) => e.key === "Enter" && this.handleSave(u.id, "email")}
										/>
									</td><td>
										<InputGroup
											fill={true}
											style={{ minWidth: "150px" }}
											value={editing[u.id]?.phone ?? u.phone ?? ""}
											onChange={(e) => this.handleEdit(u.id, "phone", e.target.value)}
											onBlur={() => this.handleSave(u.id, "phone")}
											onKeyDown={(e) => e.key === "Enter" && this.handleSave(u.id, "phone")}
										/>
									</td>
									{/* <td>{u.phone}</td> */}
									<td>{u.created_at.split(' ')[0]}</td>
								</tr>
							))}
						</tbody>
					</table>
				}
			</div>
		);
	}
}

export default SuperAdminAdmins;
